import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import machineReducer from './slices/machineSlice';
import bookingReducer from './slices/bookingSlice';
import vendorReducer from './slices/vendorSlice';
import adminReducer from './slices/adminSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    machines: machineReducer,
    bookings: bookingReducer,
    vendor: vendorReducer,
    admin: adminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
